const TNT_LOGIN_URL = "https://www12.trakntell.com/tnt/servlet/tntAndroidLogin";

export const loginWithTNT = async (userid, password) => {
  const params = new URLSearchParams({
    userid,
    password,
    os: "android",
    vc: "238",
    vn: "0.1.1",
    gcmtoken: "abcd1234",
    register: "on",
    type: "FCM",
    json: "y",
  });

  const response = await fetch(`${TNT_LOGIN_URL}?${params.toString()}`, {
    method: "POST",
  });

  return await response.json();
};

export const logoutUser = () => {
  localStorage.removeItem("tnt_userid");
  localStorage.removeItem("tnt_orgid");
  localStorage.removeItem("tnt_orgname");
};

export const getAuthUser = () => {
  const userid = localStorage.getItem("tnt_userid");
  const orgid = localStorage.getItem("tnt_orgid");
  if (userid && orgid) return { userid, orgid };
  return null;
};
